import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError, ConnectionMessage } from "../common/Exports";
var PathHeaderName = "Path";
var ContentTypeHeaderName = "Content-Type";
var RequestIdHeaderName = "X-RequestId";
var RequestTimestampHeaderName = "X-Timestamp";
var RequestStreamIdHeaderName = "x-streamid";
export var SpeechConnectionMessage = /*#__PURE__*/function (_ConnectionMessage) {
  _inherits(SpeechConnectionMessage, _ConnectionMessage);

  var _super = _createSuper(SpeechConnectionMessage);

  function SpeechConnectionMessage(messageType, path, requestId, contentType, body, streamId, additionalHeaders, id) {
    var _this;

    _classCallCheck(this, SpeechConnectionMessage);

    if (!path) {
      throw new ArgumentNullError("path");
    }

    if (!requestId) {
      throw new ArgumentNullError("requestId");
    }

    var headers = {};
    headers[PathHeaderName] = path;
    headers[RequestIdHeaderName] = requestId;
    headers[RequestTimestampHeaderName] = new Date().toISOString();

    if (contentType) {
      headers[ContentTypeHeaderName] = contentType;
    }

    if (streamId) {
      headers[RequestStreamIdHeaderName] = streamId;
    }

    if (additionalHeaders) {
      for (var headerName in additionalHeaders) {
        if (headerName) {
          headers[headerName] = additionalHeaders[headerName];
        }
      }
    }

    if (id) {
      _this = _super.call(this, messageType, body, headers, id);
    } else {
      _this = _super.call(this, messageType, body, headers);
    }

    _this.privPath = path;
    _this.privRequestId = requestId;
    _this.privContentType = contentType;
    _this.privStreamId = streamId;
    _this.privAdditionalHeaders = additionalHeaders;
    return _possibleConstructorReturn(_this);
  }

  _createClass(SpeechConnectionMessage, [{
    key: "path",
    get: function get() {
      return this.privPath;
    }
  }, {
    key: "requestId",
    get: function get() {
      return this.privRequestId;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this.privContentType;
    }
  }, {
    key: "streamId",
    get: function get() {
      return this.privStreamId;
    }
  }, {
    key: "additionalHeaders",
    get: function get() {
      return this.privAdditionalHeaders;
    }
  }]);

  return SpeechConnectionMessage;
}(ConnectionMessage);

SpeechConnectionMessage.fromConnectionMessage = function (message) {
  var path = null;
  var requestId = null;
  var contentType = null;
  var requestTimestamp = null;
  var streamId = null;
  var additionalHeaders = {};

  if (message.headers) {
    for (var headerName in message.headers) {
      if (headerName) {
        if (headerName.toLowerCase() === PathHeaderName.toLowerCase()) {
          path = message.headers[headerName];
        } else if (headerName.toLowerCase() === RequestIdHeaderName.toLowerCase()) {
          requestId = message.headers[headerName];
        } else if (headerName.toLowerCase() === RequestTimestampHeaderName.toLowerCase()) {
          requestTimestamp = message.headers[headerName];
        } else if (headerName.toLowerCase() === ContentTypeHeaderName.toLowerCase()) {
          contentType = message.headers[headerName];
        } else if (headerName.toLowerCase() === RequestStreamIdHeaderName.toLowerCase()) {
          streamId = message.headers[headerName];
        } else {
          additionalHeaders[headerName] = message.headers[headerName];
        }
      }
    }
  }

  return new SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, streamId, additionalHeaders, message.id);
};